import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13cad97e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  key: 0,
  class: "mHeaderTop"
}
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "giftIcon" }, null, -1))

import {
  DownloadDecHub,
  LanguageSelect,
  MenusMain,
  Login,
} from "@/layout/header/index";
import { ref, computed } from "vue";
import { useRoute } from "vue-router";
import LoginDialog from "@/components/Login/Index.vue";
import RegisterDialog from "@/components/Register/Index.vue";
import store from "@/store/index";
import { getCookie } from "@/utils/cookies";
import DownloadInMobile from "@/components/DownloadInMobile.vue";
import router from "@/router";
// 判断是否为新手引导状态

export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const driverState = computed(() => !!store.getters.getDriverState);
if (getCookie("token")) {
  store.dispatch("getUserInfo");
}
const showMobileDownloadTips = computed(
  () => !!store.state.showMobileDownloadTips
);
const isMobile = computed(() => !!store.state.isMobile);
const isLogin = computed(() => !!store.state.isLogin);
const route = useRoute();
const isShowBg = computed(() => {
  return (
    route.meta.mainMenuPosition !== "home" &&
    route.meta.mainMenuPosition !== "privilege" &&
    route.meta.mainMenuPosition !== "constactUs"
  );
});
const isShowNav = ref(false);

const goRedeem = () => {
  if (isLogin.value) {
    if (isMobile) {
      isShowNav.value = false;
    }
    router.push({
      path: "/pointsMall",
    });
  } else if (!isMobile.value && !isLogin.value) {
    store.commit("showLogin");
  } else {
    isShowNav.value = false;
    router.push({ path: "/login" });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isMobile))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['openHeader', { addBg: _unref(isShowBg) }])
        }, _hoisted_2, 2))
      : _createCommentVNode("", true),
    (!isShowNav.value && _unref(isMobile))
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "open",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isShowNav.value = true))
        }))
      : _createCommentVNode("", true),
    (!_unref(isMobile) || (_unref(isMobile) && isShowNav.value))
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["header", _unref(driverState) ? 'headFeel' : 'headFixed'])
        }, [
          (_unref(isMobile))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_unref(LanguageSelect)),
                (isShowNav.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "close",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (isShowNav.value = false))
                    }, "关闭"))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_unref(MenusMain), {
            onClose: _cache[2] || (_cache[2] = ($event: any) => (isShowNav.value = false))
          }),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(_unref(isMobile) ? 'giftM' : 'giftPc'),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (goRedeem()))
            }, [
              _hoisted_5,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("active_page.redeem")), 1)
            ], 2),
            (!_unref(isMobile))
              ? (_openBlock(), _createBlock(_unref(LanguageSelect), { key: 0 }))
              : _createCommentVNode("", true),
            (!_unref(isMobile))
              ? (_openBlock(), _createBlock(_unref(DownloadDecHub), { key: 1 }))
              : _createCommentVNode("", true),
            _createVNode(_unref(Login), {
              onClose: _cache[4] || (_cache[4] = ($event: any) => (isShowNav.value = false))
            })
          ])
        ], 2))
      : _createCommentVNode("", true),
    (!_unref(isMobile))
      ? (_openBlock(), _createBlock(LoginDialog, { key: 3 }))
      : _createCommentVNode("", true),
    (!_unref(isMobile))
      ? (_openBlock(), _createBlock(RegisterDialog, { key: 4 }))
      : _createCommentVNode("", true),
    (_unref(isMobile) && _unref(showMobileDownloadTips))
      ? (_openBlock(), _createBlock(DownloadInMobile, { key: 5 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})